import React , { FunctionComponent, useState, FormEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { Nav, Navbar, Container, Form, FormControl, FormLabel, Row, Col, FormGroup, Card, Button } from 'react-bootstrap'

import { loginUser } from './LoginFunctions'
import { SankeyData }  from 'open-sankey/src/types/Types'
import { NavigateFunction } from 'react-router-dom'


export type LoginTypes = {
  navbar_logo: string,
  navbar_logo_width: number,
  navbar_app_version: string,
  setToken: (_:boolean)=>void,
  setOpenSankeyPlus: (_:boolean)=>void,
  setSankeySuite: (_:boolean)=>void,
  setSankeyDev: (_:boolean)=>void,
  useNavigate:()=>NavigateFunction,
  data: SankeyData,
  set_data: (_:SankeyData)=>void,
  set_name_user: (_:string)=>void
}

// Login, Register or Buy License
const Login:FunctionComponent<LoginTypes>=({
  navbar_logo, navbar_logo_width, navbar_app_version,
  setToken,
  setOpenSankeyPlus,
  setSankeySuite,
  setSankeyDev,
  useNavigate,data,set_data,
  set_name_user
})=>
{
  const [email, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [remember] = useState(false)
  const state = {
    button: ''
  }

  // Initialise traduction function
  const {t} = useTranslation()
  // Initialise navigation function
  const navigate = useNavigate()

  // Handler : Si demande d'envoi vers page de création de compte
  const handleRegister = () => {
    navigate('/register')
  }

  // Handler : Si demande de connection
  const handleSubmit = async (e:FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (state.button === 'login') {
      await loginUser(
        t,
        {
          email,
          password,
          remember
        },
        setToken,
        setOpenSankeyPlus,
        setSankeySuite,
        setSankeyDev,
        navigate,
        set_name_user)
    }
  }

  // React output
  return(
    <div>
      <Navbar className='bg-light navbar-Account' fixed='top' style={{ 'display': 'block' }} >
        <Container className='MenuNavigation'>
          <Navbar.Brand href="/"><img src={navbar_logo} width={navbar_logo_width ? navbar_logo_width : 200} alt="logo"/> {navbar_app_version} </Navbar.Brand>
          <Nav>
            <Nav.Item>
              <Button variant='light' onClick={()=>{navigate('/')
                set_data({...data})
              }}>{t('UserPages.to_app')}</Button>
            </Nav.Item>
          </Nav>
        </Container>
      </Navbar>

      <div className="login-wrapper">
        <Card style={{'marginTop':'175px'}}>
          <Card.Header style={{'textAlign':'center'}}>{t('Login.con_win')}</Card.Header>
          <Card.Body>
            <Form  onSubmit={handleSubmit}>
              <FormGroup as={Row} fluid='xl'>
                <Col xl={4}>
                  <FormLabel>{t('UserPages.id')}</FormLabel>
                </Col>
                <Col xl={8}>
                  <FormControl type="text" onChange={e => setUserName(e.target.value)} />
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col xl={4}>
                  <FormLabel>{t('UserPages.mdp')}</FormLabel>
                </Col>
                <Col xl={8}>
                  <FormControl type="password"  onChange={e => setPassword(e.target.value)}/>
                </Col>
              </FormGroup>
              <div className='LogError' style={{'color':'red'}}></div>
              <div style={{'textAlign':'center'}}>
                <button
                  style={{'marginTop':'15px'}}
                  className='btn-login'
                  type="submit"
                  onClick={() => (state.button = 'login')}>
                  {t('Login.con')}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
        <button
          style={{'marginTop':'15px'}}
          className='btn-login to-register'
          type="button"
          onClick={() => handleRegister()}>
          {t('UserPages.to_reg')}
        </button>
      </div>
    </div>
  )
}

export default Login




